import { Box, Checkbox, FormControlLabel } from "@mui/material";
import * as React from "react";
import { ConfirmationDialogResult } from "ui/Scripts/source/models/enums";
import { Translations } from "ui/Scripts/source/models/translations";
import { AppUtils } from "../../../framework/appUtils";
import { SaveDataObj } from "../../../framework/saveData";
import { ConfirmationButton } from "../../framework/Button/ConfirmationButton";
import { FormField } from "../../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/components/framework/FormField";
import { PageDrawer } from "../../framework/Page/PageDrawer";
import { AppSettingsIcon } from "source/components/framework/Icon/AppSettingsIcon";
import { AppButton } from "ui/Scripts/source/components/framework/Button/AppButton";
import { ReportFilterPanelShowInFrontPage } from "source/components/framework/Report/ReportFilterPanelShowInFrontPage";
import { IdTitleDropdown } from "ui/Scripts/source/components/framework/Dropdown/IdTitleDropdown";

export interface IFrontPanelPropertiesDrawerProp {
    classes?: string;
    title: string;
    panelSize: number;
    panelType: number;
    visible: boolean;
    showInFrontPage?: boolean;
    hidePanelSize?: boolean;
    enableShowInFrontPage?: boolean;
    onOk: (panelType: number, panelSize: number, visible: boolean, showInFrontPage?: boolean) => void;
    onCancel: () => void;
}

export interface IFrontPanelPropertiesDrawerState {
    panelSize: string;
    visible: boolean;
    showInFrontPage: boolean;
}

export class FrontPanelPropertiesDrawer extends React.Component<IFrontPanelPropertiesDrawerProp, IFrontPanelPropertiesDrawerState> {
    private orgStateHash: string = "";

    constructor(props: IFrontPanelPropertiesDrawerProp) {
        super(props);
        this.state = {
            panelSize: props.panelSize.toString(10),
            visible: props.visible,
            showInFrontPage: props.showInFrontPage || false,
        };
        const saveData = this.getSaveDataFromState(props, this.state);
        this.orgStateHash = saveData.hash;
    }

    changeVisibility = (visible: boolean) => {
        this.setState({ visible });
    };

    getSaveDataFromState = (props: IFrontPanelPropertiesDrawerProp, state: IFrontPanelPropertiesDrawerState): SaveDataObj => {
        const result = new SaveDataObj();
        result.append("panelSize", state.panelSize);
        return result;
    };

    saveToDb = async () => {
        const props = this.props;
        const state = this.state;
        props.onOk(props.panelType, state.panelSize.toInteger(), state.visible, state.showInFrontPage);
    };

    handleSave = () => {
        this.saveToDb();
    };

    handleCancel = async () => {
        const props = this.props;
        const state = this.state;
        const cancelResult = await AppUtils.cancel(this.getSaveDataFromState(props, state).hash, this.orgStateHash, null);
        if (cancelResult === ConfirmationDialogResult.Cancel) return;
        if (cancelResult === ConfirmationDialogResult.Yes) {
            this.saveToDb();
        } else {
            props.onCancel();
        }
    };

    handleClear = () => {
        this.setState({ panelSize: "1" });
    };

    render() {
        const props = this.props;
        const state = this.state;
        return (
            <PageDrawer
                open={true}
                icon={<AppSettingsIcon />}
                title={props.title}
                parentTitle={Translations.Panels}
                onClose={this.handleCancel}
            >
                <Box display="flex" flexDirection="column" flexGrow={2} margin="24px">
                    <Box display="flex">
                        <FormControlLabel
                            label={Translations.PanelVisible}
                            control={
                                <Checkbox
                                    checked={state.visible}
                                    onChange={() => this.changeVisibility(!state.visible)}
                                />
                            } />
                    </Box>
                    {!props.hidePanelSize &&
                        <Box display="flex" flexGrow={2}>
                            <FormField title={Translations.PanelSize} fullWidth>
                                <IdTitleDropdown
                                    selectedId={state.panelSize}
                                    items={[
                                        { id: "1", title: Translations.PanelSize1 },
                                        { id: "2", title: Translations.PanelSize2 },
                                        { id: "5", title: Translations.PanelSize5 },
                                        { id: "3", title: Translations.PanelSize3 },
                                        { id: "4", title: Translations.PanelSize4 },
                                        { id: "6", title: Translations.PanelSize6 }
                                    ]}
                                    onChange={(panelSize) => this.setState({ panelSize })}
                                />
                            </FormField>
                        </Box>
                    }
                    {!!props.enableShowInFrontPage &&
                        <Box sx={{ marginTop: "1rem" }}>
                            <ReportFilterPanelShowInFrontPage
                                title={Translations.ShowChartInFrontPage}
                                showInFrontPage={state.showInFrontPage}
                                onChangeShowInFrontPage={(showInFrontPage: boolean) => this.setState({ showInFrontPage })}
                            />
                        </Box>

                    }
                    <Box display="flex" justifyContent="space-between" marginTop="1.5rem">
                        <AppButton variant="outlined" onClick={this.handleClear}>
                            {Translations.Clear}
                        </AppButton>
                        <Box display="flex">
                            <AppButton variant="outlined" onClick={this.handleCancel}>
                                {Translations.Close}
                            </AppButton>
                            <ConfirmationButton onClick={this.handleSave} sx={{ marginLeft: "24px" }}>
                                {Translations.Save}
                            </ConfirmationButton>
                        </Box>
                    </Box>
                </Box>
            </PageDrawer>
        );
    }
}